// @flow
import styles from './Pagination.less';

import { connect } from 'react-redux';
import classnames from 'classnames';
import React from 'react';

import { Hidden } from 'seek-style-guide/react';
import NavLink from 'src/components/NavLink/NavLink';

type Props = {
  query: SearchParams,
  linkState?: Object, // paginationParameters_1..n
  currentPageNumber?: number,
  pagination?: GiantPiano
};

function mapStateToProps({ search, location, results }) {
  const { paginationParameters } = results;

  return {
    query: search.query,
    linkState: { paginationParameters },
    currentPageNumber: location.pageNumber,
    pagination: results.pagination
  };
}

const Pagination = ({
  query,
  currentPageNumber = 0,
  pagination,
  linkState
}: Props) => {
  if (pagination === null) {
    return null;
  }

  const { showPrev, pages, showNext } = pagination || {};

  const lastPageNumber = pages.length;
  const prevPageNumber = currentPageNumber - 1;
  const nextPageNumber = currentPageNumber + 1;
  const isFistPage = currentPageNumber === 1;
  const isLastPage = currentPageNumber === lastPageNumber;

  const commonLocationProps = {
    pathname: '/jobs',
    state: linkState
  };

  const prevProps = {
    location: {
      ...commonLocationProps,
      query: { ...query, ...{ page: prevPageNumber } }
    },
    rel: 'prev',
    'data-automation': 'page-prev'
  };

  const nextProps = {
    location: {
      ...commonLocationProps,
      query: { ...query, ...{ page: nextPageNumber } }
    },
    rel: 'next',
    'data-automation': 'page-next'
  };

  const showExtraSidePages = (page, extraSidePagesNumber) =>
    (page >= currentPageNumber - extraSidePagesNumber &&
      page <= currentPageNumber + extraSidePagesNumber) ||
    (isFistPage && page === currentPageNumber + extraSidePagesNumber + 1) ||
    (isLastPage && page === lastPageNumber - extraSidePagesNumber - 1);

  return (
    <p className={styles.root}>
      {showPrev && (
        <NavLink className={styles.previous} {...prevProps}>
          Prev
        </NavLink>
      )}
      {pages.map(page =>
        currentPageNumber === page ? (
          <span
            className={classnames(styles.page, styles.page_isActive)}
            key={page}
          >
            {page}
          </span>
        ) : (
          <Hidden key={page} mobile={!showExtraSidePages(page, 1)}>
            <NavLink
              className={styles.page}
              location={{
                ...commonLocationProps,
                query: { ...query, ...{ page } }
              }}
              data-automation={`page-${page}`}
              key={page}
            >
              {page}
            </NavLink>
          </Hidden>
        )
      )}
      {showNext && (
        <NavLink className={styles.next} {...nextProps}>
          Next
        </NavLink>
      )}
    </p>
  );
};

export default connect(mapStateToProps)(Pagination);
